import React from 'react';
import { Skeleton, SimpleGrid } from '@mantine/core';

export interface RegistryGridSkeletonProps {
  count?: number;
}

/** Loading placeholder for registry model grid cards. */
export function RegistryGridSkeleton ({ count = 6 }: RegistryGridSkeletonProps) {
  return (
    <SimpleGrid
      cols={{ base: 1, sm: 2, md: 3 }}
      spacing={12}
      sx={{
        padding: '16px 24px',
        '@media (max-width: 639px)': { padding: '16px 24px' }
      }}
    >
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} height={180} radius="md" />
      ))}
    </SimpleGrid>
  );
}
